import React, { useEffect, useState } from "react";
import { useActionData, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Dashcomponent from "./dashcomponent";
import RechargeHistory from "../component/Reports/RechargeHistory";
import Bbpshistory from "../component/Reports/Bbpshistory";
import Payoutreport from "../component/Reports/Payoutreport";
import RechargeCommission from "../component/Reports/RechargeCommission";
import UpiCollectionHistory from "../component/Reports/UpiCollectionHistory";
import UpiChargebackhistory from "../component/Reports/UpiChargebackhistory";
import OpenpayoutReport from "../component/Reports/OpenpayoutReport";
import UpipayoutReport from "../component/Reports/UpipayoutReport";
import MyRechargeCommission from "../component/Mycommision/MyRechargeCommission";
import BillPayCommission from "../component/Mycommision/BillPayCommission";
import UpiCollectionCharges from "../component/Mycommision/UpiCollectionCharges";
import Mywallet from "../component/Mainwallet/Mywallet";
import OldwalletReport from "../component/Mainwallet/OldwalletReport";
import MyFundRequest from "../component/Mainwallet/MyFundRequest";
import ApiFundRequest from "../component/Mainwallet/ApiFundRequest";
import VirtualAccount from "../component/Mainwallet/VirtualAccount";
import Myupiwallet from "../component/UpiWallet/Myupiwallet";
import axios from "axios";
import MainWalletTransfer from "../component/UpiWallet/MainWalletTransfer";
import CreateTicket from "../component/Supportticket/CreateTicket";
import ViewTicket from "../component/Supportticket/ViewTicket";
import OpenMoneyPayoutDocument from "../component/Apiocument/OpenMoneyPayoutDocument";
import PayoutApiDocument from "../component/Apiocument/PayoutApiDocument";
import PenneyDropApiDocument from "../component/Apiocument/PenneyDropApiDocument";
import RechargeApiDocument from "../component/Apiocument/RechargeApiDocument";
import UpiQronlyApiDocument from "../component/Apiocument/UpiQronlyApiDocument";
import MyProfile from "../component/Setting/MyProfile";
import ChangePassword from "../ChangePassword";
import ViewwholeTicket from "../component/Supportticket/ViewwholeTicket";
import { baseurl } from "../constant";

const Home = () => {
  const [result, setresult] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [mainwallet, setmainwallet] = useState(0);
  const [upiwallet, setupiwallet] = useState(0);
  const [holdamount, setholdamount] = useState(0);
  const [rechargeActiveStatus, setrechargeActiveStatus] = useState();
  const [bbpsActiveStatus, setbbpsActiveStatus] = useState();
  const [payoutActiveStatus, aetpayoutActiveStatus] = useState();
  const [openPayoutActiveStatus, setopenPayoutActiveStatus] = useState();
  const [aepsActiveStatus, setaepsActiveStatus] = useState();
  const [upiActiveStatus, setupiActiveStatus] = useState();
  const [news, setnews] = useState();
  const [name, setname] = useState();
  const [error, seterror] = useState();
  const [upipayoutreport, setupipayoutstatus] = useState();
  const [isVirtualAccountActive, setisVirtualAccountActive] = useState();
  const [virtualAccountNo, setvirtualAccountNo] = useState();
  const [ifsc, setifsc] = useState();
  const [bankname, setbankname] = useState();
  const [email, setemail] = useState();
  const [mobile, setmobile] = useState();
  const [pmrtoken, setpmrtoken] = useState();
  const [rechargeCallbackUrl, setrechargeCallbackUrl] = useState();
  const [upiCallbackUrl, setupiCallbackUrl] = useState();
  const [openPayoutCallbackUrl, setopenPayoutCallbackUrl] = useState();
  const [membetid, setmemberid] = useState();
  const formattedNumber = (number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(number);

  const navigate = useNavigate();

  const location = useLocation();

  const logout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const token = localStorage.getItem("authToken");
  const dataresult = async () => {
    try {
      setLoading(true);
      const result = await axios.post(baseurl + "userDataAuth", {
        token: token,
      });
      setLoading(false);

      setnews(result.data.news);
      setresult(result.data.news);
      setmainwallet(result.data.mainWalletBal);
      setupiwallet(result.data.upiWalletBal);
      setholdamount(result.data.holdAmount);
      setname(result.data.name);
      setrechargeActiveStatus(result.data.rechargeActiveStatus);
      setbbpsActiveStatus(result.data.bbpsActiveStatus);
      aetpayoutActiveStatus(result.data.payoutActiveStatus);
      setopenPayoutActiveStatus(result.data.openPayoutActiveStatus);
      setaepsActiveStatus(result.data.aepsActiveStatus);
      setupiActiveStatus(result.data.upiActiveStatus);
      setisVirtualAccountActive(result.data.isVirtualAccountActive);
      setvirtualAccountNo(result.data.virtualAccountNo);
      setifsc(result.data.ifsc);
      setbankname(result.data.bankname);
      setemail(result.data.email);
      setpmrtoken(result.data.pmrToken);
      setmobile(result.data.mobile);
      setrechargeCallbackUrl(result.data.rechargeCallbackUrl);
      setupiCallbackUrl(result.data.upiCallbackUrl);
      setopenPayoutCallbackUrl(result.data.openPayoutCallbackUrl);
      setmemberid(result.data.usercode);
    } catch (err) {
      seterror(err);
    }
  };

  const handleSearch = (event) => {
    setSearchInput(event.target.value.toLowerCase());
  };

  const [message, setmessage] = useState("");
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loginauth = async () => {
      try {
        const token1 = await location.state?.token1;
        if (!token) {
          navigate("/login");
          alert("please login");
        } else if (token === token1) {
          dataresult();
        } else {
          navigate("/login");
          alert("please login");
        }
      } catch (err) {
        navigate("/login");
      }
    };
    loginauth();
  }, []);

  return (
    <>
      {error ? (
        <div>
          <h1>api network err</h1>
        </div>
      ) : (
        <body id="page-top">
          <h1>{loading}</h1>
          <input type="hidden" id="siteUrl" value="https://www.payol.in/" />
          <div className="large-loader">
            <img src="https://www.payol.in/skin/admin/images/large-loading.gif" />
          </div>

          <div id="wrapper">
            <ul
              className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
              id="accordionSidebar"
            >
              <a className="sidebar-brand d-flex align-items-center justify-content-center">
                <div className="sidebar-brand-icon">
                  <img
                    src="https://www.payol.in/media/account/677363070.png"
                    className="img-responsive"
                  />
                </div>
              </a>

              <hr className="sidebar-divider my-0" />

              <li className="nav-item">
                <a className="nav-link">
                  <i className="fas fa-fw fa-tachometer-alt"></i>
                  <span
                    onClick={() => setActive(0)}
                    style={{ cursor: "pointer" }}
                  >
                    Dashboard
                  </span>
                </a>
              </li>

              {/* <li className="nav-item">
                <a className="nav-link" href="https://www.payol.in/portal/kyc">
                  <i className="fas fa-fw fa-user-alt"></i>
                  <span>User Onboarding</span>
                </a>
              </li> */}

              <hr className="sidebar-divider my-0" />

              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse10"
                  aria-expanded="true"
                  aria-controls="collapse10"
                >
                  <i className="fa fa-list"></i>
                  <span>Reports</span>
                </a>
                <div
                  id="collapse10"
                  className="collapse"
                  s
                  aria-labelledby="heading10"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Reports:</h6>
                    {rechargeActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/recharge"
                        onClick={() => setActive(1)}
                        style={{ cursor: "pointer" }}
                      >
                        Recharge History
                      </span>
                    )}
                    {bbpsActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/bbps"
                        onClick={() => setActive(2)}
                        style={{ cursor: "pointer" }}
                      >
                        BBPS History
                      </span>
                    )}
                    {payoutActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/payoutReport"
                        onClick={() => setActive(3)}
                        style={{ cursor: "pointer" }}
                      >
                        Payout Report
                      </span>
                    )}

                    {openPayoutActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/newPayoutReport"
                        onClick={() => setActive(4)}
                        style={{ cursor: "pointer" }}
                      >
                        Open Payout Report
                      </span>
                    )}
                    {rechargeActiveStatus == 1 && (
                      <sapn
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/rechargeCommision"
                        onClick={() => setActive(5)}
                        style={{ cursor: "pointer" }}
                      >
                        Recharge Commission
                      </sapn>
                    )}
                    {upiActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiCollectionReport"
                        onClick={() => setActive(6)}
                        style={{ cursor: "pointer" }}
                      >
                        UPI Collection History
                      </span>
                    )}
                    {upiActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiChargebackReport"
                        onClick={() => setActive(7)}
                        style={{ cursor: "pointer" }}
                      >
                        UPI Chargeback History
                      </span>
                    )}
                    {openPayoutActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiChargebackReport"
                        onClick={() => setActive(8)}
                        style={{ cursor: "pointer" }}
                      >
                        UPI Payout Report
                      </span>
                    )}

                    {/* {aepsActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiChargebackReport"
                        onClick={() => setActive(8)}
                        style={{ cursor: "pointer" }}
                      >
                        My AEPS Commission
                      </span>
                    )} */}
                    {/* {aepsActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiChargebackReport"
                        onClick={() => setActive(8)}
                        style={{ cursor: "pointer" }}
                      >
                        AEPS History
                      </span>
                    )} */}
                    {/* {aepsActiveStatus == 1 && (
                      <span
                        className="collapse-item"
                        // href="https://www.payol.in/portal/report/upiChargebackReport"
                        onClick={() => setActive(8)}
                        style={{ cursor: "pointer" }}
                      >
                        AEPS Kyc
                      </span>
                    )} */}
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider my-0" />

              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse111"
                  aria-expanded="true"
                  aria-controls="collapse111"
                >
                  <i className="fa fa-list"></i>
                  <span>My Commision</span>
                </a>
                <div
                  id="collapse111"
                  className="collapse"
                  aria-labelledby="heading10"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Master Setting:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/master/myCommission"
                      onClick={() => setActive(9)}
                      style={{ cursor: "pointer" }}
                    >
                      Recharge Commission
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/master/myBbpsCommission"
                      onClick={() => setActive(10)}
                      style={{ cursor: "pointer" }}
                    >
                      Bill Pay Commission
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/master/myUpiCommision"
                      onClick={() => setActive(11)}
                      style={{ cursor: "pointer" }}
                    >
                      UPI Collection Charge
                    </a>
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider my-0" />
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse8"
                  aria-expanded="true"
                  aria-controls="collapse8"
                >
                  <i className="fa fa-file"></i>
                  <span>Main Wallet</span>
                </a>
                <div
                  id="collapse8"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Main Wallet:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/myWalletList"
                      onClick={() => setActive(12)}
                      style={{ cursor: "pointer" }}
                    >
                      My Wallet
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/oldWalletList"
                      onClick={() => setActive(13)}
                      style={{ cursor: "pointer" }}
                    >
                      Old Wallet Report
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/myRequestList"
                      onClick={() => setActive(14)}
                      style={{ cursor: "pointer" }}
                    >
                      My Fund Request
                    </a>
                    {/* <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/apiRequestList"
                      onClick={() => setActive(15)}
                      style={{ cursor: "pointer" }}
                    >
                      Api Fund Request
                    </a> */}

                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/virtualAccount"
                      onClick={() => setActive(16)}
                      style={{ cursor: "pointer" }}
                    >
                      Virtual Account
                    </a>
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider my-0" />
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapseUpiWallet"
                  aria-expanded="true"
                  aria-controls="collapseUpiWallet"
                >
                  <i className="fa fa-file"></i>
                  <span>UPI Wallet</span>
                </a>
                <div
                  id="collapseUpiWallet"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Main Wallet:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/myUpiWalletList"
                      onClick={() => setActive(17)}
                      style={{ cursor: "pointer" }}
                    >
                      My Wallet
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/wallet/mainwalletTransfer"
                      onClick={() => setActive(18)}
                      style={{ cursor: "pointer" }}
                    >
                      Main Wallet Transfer
                    </a>
                  </div>
                </div>
              </li>
              <hr className="sidebar-divider my-0" />
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse9"
                  aria-expanded="true"
                  aria-controls="collapse9"
                >
                  <i className="fa fa-life-ring"></i>
                  <span>Support Ticket</span>
                </a>
                <div
                  id="collapse9"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Support Ticket:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/ticket/create"
                      onClick={() => setActive(19)}
                      style={{ cursor: "pointer" }}
                    >
                      Create Ticket
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/ticket/ticketList"
                      onClick={() => setActive(20)}
                      style={{ cursor: "pointer" }}
                    >
                      View Ticket
                    </a>
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider my-0" />
              {/* <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse99"
                  aria-expanded="true"
                  aria-controls="collapse99"
                >
                  <i className="fa fa-life-ring"></i>
                  <span>Complain</span>
                </a>
                <div
                  id="collapse99"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Complain:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/complain"
                    >
                      View Complain
                    </a>
                  </div>
                </div>
              </li> */}
              <hr className="sidebar-divider my-0" />
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse11"
                  aria-expanded="true"
                  aria-controls="collapse11"
                >
                  <i className="fa fa-file"></i>
                  <span>API Document</span>
                </a>
                <div
                  id="collapse11"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">API Document:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/document/recharge"
                      onClick={() => setActive(21)}
                      style={{ cursor: "pointer" }}
                    >
                      Recharge
                    </a>

                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/document/moneyTransfer"
                      onClick={() => setActive(22)}
                      style={{ cursor: "pointer" }}
                    >
                      Payout
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/document/pennyDrop"
                      onClick={() => setActive(23)}
                      style={{ cursor: "pointer" }}
                    >
                      Penny Drop
                    </a>

                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/document/upiQr"
                      onClick={() => setActive(24)}
                      style={{ cursor: "pointer" }}
                    >
                      UPI QR Only
                    </a>

                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/document/OpenMoneyPayout"
                      onClick={() => setActive(25)}
                      style={{ cursor: "pointer" }}
                    >
                      Open Money Payout
                    </a>
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider my-0" />
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapse13"
                  aria-expanded="true"
                  aria-controls="collapse13"
                >
                  <i className="fa fa-cog"></i>
                  <span>Setting</span>
                </a>
                <div
                  id="collapse13"
                  className="collapse"
                  aria-labelledby="heading8"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Setting:</h6>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/setting/profile"
                      onClick={() => setActive(26)}
                      style={{ cursor: "pointer" }}
                    >
                      My Profile
                    </a>
                    <a
                      className="collapse-item"
                      // href="https://www.payol.in/portal/setting/changePassword"
                      onClick={() => setActive(27)}
                      style={{ cursor: "pointer" }}
                    >
                      Change Password
                    </a>
                    <a
                      className="collapse-item"
                      href="#"
                      data-toggle="modal"
                      data-target="#logoutModal"
                    >
                      Logout
                    </a>
                  </div>
                </div>
              </li>
              <hr class="sidebar-divider" />

              <div class="text-center d-none d-md-inline">
                <button
                  class="rounded-circle border-0"
                  id="sidebarToggle"
                ></button>
              </div>
            </ul>

            <hr className="sidebar-divider" />
            <div className="text-center d-none d-md-inline">
              <button
                className="rounded-circle border-0"
                id="sidebarToggle"
              ></button>
            </div>

            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <div className="nav_header bg-white static-top shadow mb-4">
                  <nav className="navbar navbar-expand navbar-light topbar">
                    <button
                      id="sidebarToggleTop"
                      className="btn btn-link d-md-none rounded-circle mr-3"
                    >
                      <i className="fa fa-bars"></i>
                    </button>
                    <h4>Payol Digital Technologies Pvt ltd.</h4>

                    <ul className="navbar-nav ml-auto">
                      <li
                        className="nav-item dropdown"
                        style={{
                          paddingTop: "25px",
                          paddingRight: "25px",
                        }}
                      >
                        <h6>
                          <b>Main Wallet : {formattedNumber(mainwallet)}</b>
                        </h6>
                      </li>

                      <li
                        className="nav-item dropdown"
                        style={{ paddingTop: "25px", paddingRight: "25px" }}
                      >
                        <h6>
                          <b>UPI Wallet : {formattedNumber(upiwallet)}</b>
                        </h6>
                      </li>
                      {/* <!--<li className="nav-item dropdown" style="padding-top: 25px; padding-right: 25px;">-->
            <!--<h6>-->
            <!--<b>Commision Balance : &#8377; 0.00</b>-->
            <!--</h6>  -->
            <!--</li>--> */}
                      <li
                        className="nav-item dropdown"
                        style={{ paddingTop: "25px", paddingRight: "25px" }}
                      >
                        <h6>
                          <b>Hold Amount : {formattedNumber(holdamount)}</b>
                        </h6>
                      </li>

                      <div className="topbar-divider d-none d-sm-block"></div>

                      <li className="nav-item dropdown no-arrow">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          id="userDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                            {name}
                            <br />( {membetid} )
                          </span>
                          <img
                            className="img-profile rounded-circle"
                            src="https://www.payol.in/skin/admin/img/user.png"
                          />
                        </a>

                        <div
                          className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                          aria-labelledby="userDropdown"
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => setActive(26)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            Profile
                          </a>
                          <div className="dropdown-divider"></div>
                          <button
                            className="dropdown-item"
                            href="#"
                            data-toggle="modal"
                            data-target="#logoutModal"
                          >
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                          </button>
                        </div>
                      </li>
                    </ul>
                  </nav>
                  <div className="news_toop">
                    <marquee>
                      <ol>
                        {news ? news.map((item) => <li>{item.news}</li>) : ""}
                      </ol>
                    </marquee>
                  </div>
                </div>

                {active === 0 && <Dashcomponent />}
                {active === 1 && <RechargeHistory />}
                {active === 2 && <Bbpshistory />}
                {active === 3 && <Payoutreport />}
                {active === 4 && <OpenpayoutReport />}
                {active === 5 && <RechargeCommission />}
                {active === 6 && <UpiCollectionHistory />}
                {active === 7 && <UpiChargebackhistory />}
                {active === 8 && <UpipayoutReport />}
                {active === 9 && <MyRechargeCommission />}
                {active === 10 && <BillPayCommission />}
                {active === 11 && <UpiCollectionCharges />}
                {active === 12 && <Mywallet />}
                {active === 13 && <OldwalletReport />}
                {active === 14 && <MyFundRequest />}
                {/* {active === 15 && <ApiFundRequest />} */}
                {active === 16 && (
                  <VirtualAccount
                    VirtualAccountActive={isVirtualAccountActive}
                    virtualAccountNo={virtualAccountNo}
                    ifsc={ifsc}
                    bankname={bankname}
                  />
                )}
                {active === 17 && <Myupiwallet />}
                {active === 18 && <MainWalletTransfer upiwallet={upiwallet} />}
                {active === 19 && <CreateTicket />}
                {active === 20 && <ViewTicket />}
                {active === 21 && (
                  <RechargeApiDocument
                    rechargeCallbackUrl={rechargeCallbackUrl}
                  />
                )}
                {active === 22 && <PayoutApiDocument />}
                {active === 23 && <PenneyDropApiDocument />}
                {active === 24 && (
                  <UpiQronlyApiDocument upiCallbackUrl={upiCallbackUrl} />
                )}
                {active === 25 && (
                  <OpenMoneyPayoutDocument
                    openPayoutCallbackUrl={openPayoutCallbackUrl}
                  />
                )}
                {active === 26 && (
                  <MyProfile
                    name={name}
                    email={email}
                    mobile={mobile}
                    pmrToken={pmrtoken}
                  />
                )}
                {active === 27 && <ChangePassword />}

                {/* {active === 10 && <BillPayCommission />}
                {active === 10 && <BillPayCommission />}
                {active === 10 && <BillPayCommission />} */}

                {/* <div className="container-fluid">
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-md-12">
                  <div className="alert alert-danger alert-dismissable">
                    Kindly complete your KYC to use the services.{" "}
                    <a
                      href="https://www.payol.in/portal/kyc"
                      className="text-primary"
                    >
                      {" "}
                      Do Kyc Now
                    </a>
                  </div>
                  <h1 className="h3 mb-0 text-gray-800">
                    Welcome to API Panel{" "}
                  </h1>
                </div>
              </div>

              <div className="dash_card card shadow">
                <div className="card_heading">
                  <h1 className="h3 mb-0 text-gray-800">Total Summary</h1>
                </div>
                <div className="row card_row_col">
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">TOTAL DEBIT FUND</a>
                      </h5>
                      <h3>₹ 1,107.70 / 33</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">TOTAL CREDIT FUND</a>
                      </h5>
                      <h3>₹ 1,537.00 / 16</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">TOTAL SUCCESS PAYOUT</a>
                      </h5>
                      <h3>₹ 430.00 / 7</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">TOTAL PENDING PAYOUT</a>
                      </h5>
                      <h3>₹ 0.00 / 0</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">TOTAL FAILED PAYOUT</a>
                      </h5>
                      <h3>₹ 400.00 / 4</h3>
                    </div>
                  </div>
                </div>
              </div>

              <div className="dash_card card shadow">
                <div className="card_heading">
                  <h1 className="h3 mb-0 text-gray-800">Today Summary</h1>
                </div>
                <div className="row card_row_col">
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">OPENING BALANCE</a>
                      </h5>
                      <h3>₹ 0.00</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">PURCHASE BALANCE</a>
                      </h5>
                      <h3>₹ 0.00 / 0</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="https://www.payol.in/portal/report/newPayoutReport/3">
                          SUCCESS PAYOUT
                        </a>
                      </h5>
                      <h3>₹ 0.00 / 0</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="https://www.payol.in/portal/report/newPayoutReport/2">
                          PENDING PAYOUT
                        </a>
                      </h5>
                      <h3>₹ 0.00 / 0</h3>
                    </div>
                  </div>
                  <div className="col service_col">
                    <div className="card_body_dash">
                      <h5>
                        <a href="#">REFUND PAYOUT</a>
                      </h5>
                      <h3>₹ 0.00 / 0</h3>
                    </div>
                  </div>
                </div>
              </div>

               <!--  <div className="dash_card card shadow">
          <div className="card_heading">
           <h1 className="h3 mb-0 text-gray-800">Today History</h1>
         </div>
        <div className="row card_row_col">
        <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL PENDING</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div>
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div>
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL Failed</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
        </div>

         </div> --> 
            </div>*/}
              </div>

              <footer className="sticky-footer bg-white">
                <div className="container my-auto">
                  <div className="copyright text-center my-auto">
                    <span>
                      Copyright © Payol Digital Technologies Pvt ltd.2022 - 2025
                    </span>
                  </div>
                </div>
              </footer>
            </div>

            <a className="scroll-to-top rounded" href="#page-top">
              <i className="fa fa-angle-up"></i>
            </a>

            <div
              className="modal fade"
              id="logoutModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Ready to Leave?
                    </h5>
                    <button
                      className="close"
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    Select "Logout" below if you are ready to end your current
                    session.
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary btn-sm"
                      type="button"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary btn-sm"
                      data-dismiss="modal"
                      onClick={() => logout()}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </body>
      )}
    </>
  );
};

export default Home;
